import { AsYouType, format, isValidPhoneNumber } from "libphonenumber-js";
import { InputField, type InputFieldProps } from "./InputField";
export const validatePhoneNumber = (text: string): boolean => {
  return isValidPhoneNumber(text, "US");
};
export const formatPhoneNumber = (text: string): string => {
  if (text.includes("(") && !text.includes(")")) {
    return text.replace("(", "");
  }
  return new AsYouType("US").input(text);
};

/**
 * Formats a phone number consistently using libphonenumber-js
 * @param phoneNumber The phone number to format (expected as 1234567890)
 * @returns Formatted phone number or null if invalid (123) 456-7890
 */
export const formatPhoneNumberValue = (phoneNumber?: string | null): string | null => {
  if (!phoneNumber) {
    return null;
  }
  if (!isValidPhoneNumber(phoneNumber, "US")) {
    console.error("[Phone Format] Invalid phone number", phoneNumber);
    return null;
  }
  try {
    const formatted = format(phoneNumber, "US", "NATIONAL");
    return formatted;
  } catch (error) {
    console.error("[Phone Format] Error formatting phone number", error);
    return null;
  }
};
export const PhoneNumberField = (props: InputFieldProps) => {
  return <InputField formatInput={formatPhoneNumber} inputMode="numeric" keyboardType="number-pad" {...props} data-sentry-element="InputField" data-sentry-component="PhoneNumberField" data-sentry-source-file="PhoneNumberField.tsx" />;
};